export default function MembersSectionOne () {
    return (
        <section className="w-full h-96 text-xl text-gray-400 flex justify-center text-center items-center">
            Team is working on this page ..
        </section>
    )
}